import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {
    listAvailableJobs,
    getJobSchedule,
    createOrUpdateJobSchedule,
    deleteJobSchedule,
    triggerJobExecution,
    getJobExecutionHistory
} from "./API";

export const listJobsThunk = createAsyncThunk(
    'jobScheduling/listJobs',
    async (spaceId) => {
        return listAvailableJobs(spaceId)
    }
)

export const getJobScheduleThunk = createAsyncThunk(
    'jobScheduling/getSchedule',
    async ({spaceId, jobType}) => {
        return getJobSchedule(spaceId, jobType)
    }
)

export const createOrUpdateScheduleThunk = createAsyncThunk(
    'jobScheduling/createOrUpdateSchedule',
    async ({spaceId, jobType, frequency, day, enabled}) => {
        console.log('====== createOrUpdateScheduleThunk called ======');
        console.log('Args:', {spaceId, jobType, frequency, day, enabled});
        try {
            const data = { enabled };
            if (frequency !== undefined) {
                data.frequency = frequency;
            }
            if (day !== undefined) {
                data.day = day;
            }
            const result = await createOrUpdateJobSchedule(spaceId, jobType, data);
            console.log('API call successful, result:', result);
            return result;
        } catch (error) {
            console.error('API call failed:', error);
            throw error;
        }
    }
)

export const deleteScheduleThunk = createAsyncThunk(
    'jobScheduling/deleteSchedule',
    async ({spaceId, jobType}) => {
        return deleteJobSchedule(spaceId, jobType)
    }
)

export const triggerExecutionThunk = createAsyncThunk(
    'jobScheduling/triggerExecution',
    async ({spaceId, jobType}) => {
        return triggerJobExecution(spaceId, jobType)
    }
)

export const getExecutionHistoryThunk = createAsyncThunk(
    'jobScheduling/getExecutionHistory',
    async ({spaceId, jobType, limit = 20, offset = 0}) => {
        return getJobExecutionHistory(spaceId, jobType, limit, offset)
    }
)

const JobSchedulingSlice = createSlice({
    name: 'jobScheduling',
    initialState: {
        jobs: [],
        schedules: {},
        executionHistories: {},
        loading: 'idle',
        error: null,
        triggering: false
    },
    reducers: {
        clearError: (state) => {
            state.error = null
        }
    },
    extraReducers: {
        [listJobsThunk.pending]: (state) => {
            state.loading = 'loading'
            state.error = null
        },
        [listJobsThunk.fulfilled]: (state, action) => {
            state.loading = 'idle'
            state.jobs = action.payload
        },
        [listJobsThunk.rejected]: (state, action) => {
            state.loading = 'idle'
            state.error = action.error.message
        },
        [getJobScheduleThunk.pending]: (state) => {
            state.error = null
        },
        [getJobScheduleThunk.fulfilled]: (state, action) => {
            state.schedules[action.meta.arg.jobType] = action.payload
        },
        [getJobScheduleThunk.rejected]: (state, action) => {
            state.error = action.error.message
        },
        [createOrUpdateScheduleThunk.pending]: (state) => {
            state.error = null
        },
        [createOrUpdateScheduleThunk.fulfilled]: (state, action) => {
            state.schedules[action.meta.arg.jobType] = action.payload
        },
        [createOrUpdateScheduleThunk.rejected]: (state, action) => {
            state.error = action.error.message
        },
        [deleteScheduleThunk.pending]: (state) => {
            state.error = null
        },
        [deleteScheduleThunk.fulfilled]: (state, action) => {
            delete state.schedules[action.meta.arg.jobType]
        },
        [deleteScheduleThunk.rejected]: (state, action) => {
            state.error = action.error.message
        },
        [triggerExecutionThunk.pending]: (state) => {
            state.triggering = true
            state.error = null
        },
        [triggerExecutionThunk.fulfilled]: (state) => {
            state.triggering = false
        },
        [triggerExecutionThunk.rejected]: (state, action) => {
            state.triggering = false
            state.error = action.error.message
        },
        [getExecutionHistoryThunk.pending]: (state) => {
            state.error = null
        },
        [getExecutionHistoryThunk.fulfilled]: (state, action) => {
            state.executionHistories[action.meta.arg.jobType] = action.payload
        },
        [getExecutionHistoryThunk.rejected]: (state, action) => {
            state.error = action.error.message
        }
    }
})

export const { clearError } = JobSchedulingSlice.actions
export default JobSchedulingSlice.reducer
